var _a, _b;

export var AM = "AM";
export var PM = "PM";
export var ADAK = "America/Adak";
export var ANCHORAGE = "America/Anchorage";
export var CHICAGO = "America/Chicago";
export var DENVER = "America/Denver";
export var LOS_ANGELES = "America/Los_Angeles";
export var NEW_YORK = "America/New_York";
export var PHOENIX = "America/Phoenix";
export var HONOLULU = "Pacific/Honolulu";
export var AKST = "Alaska Standard Time (AKST)";
export var CST = "Central Standard Time (CST)";
export var MST = "Mountain Standard Time (MST)";
export var EST = "Eastern Standard Time (EST)";
export var HST = "Standard Time (HST)";
export var PST = "Pacific Standard Time (PST)";
export var AKDT = "Alaska Daylight Time (AKDT)";
export var MDT = "Mountain Daylight Time (MDT)";
export var PDT = "Pacific Daylight Time (PDT)";
export var EDT = "Eastern Daylight Time (EDT)";
export var TIMEZONES = (_a = {}, _a[ADAK] = AKST, _a[ANCHORAGE] = AKST, _a[CHICAGO] = CST, _a[DENVER] = MST, _a[LOS_ANGELES] = PST, _a[NEW_YORK] = EST, _a[PHOENIX] = MST, _a[HONOLULU] = HST, _a);
export var TIMEZONES_DST = (_b = {}, _b[ADAK] = AKDT, _b[ANCHORAGE] = AKDT, _b[CHICAGO] = CST, _b[DENVER] = MDT, _b[LOS_ANGELES] = PDT, _b[NEW_YORK] = EDT, _b[PHOENIX] = MDT, _b[HONOLULU] = HST, _b);